export default "__VITE_ASSET__B4NI7Ueg__"